import "./icons.scss"

export default function QuestionIcon({ iconClasses }) {
  return (
    <span styleName={`circle ${iconClasses ? iconClasses : ""}`}>
      <span styleName="center">?</span>
    </span>
  )
}
